import { FC, HTMLProps } from 'react';
import { Flex, Typography } from 'antd';
import { useLocation } from 'react-router';

import styles from './styles.module.scss';

import { ROUTES_TITLES } from '@/constants/routes.ts';
import { EAdminRoutes } from '@/services/router/enums.ts';

export const AuthorizedHeader: FC<HTMLProps<HTMLElement>> = () => {
    const location = useLocation();

    return (
        <header>
            <Flex vertical>
                <Flex align="center" className={styles['header-container']} justify="space-between">
                    <Typography.Title className={styles['title']} level={3}>
                        {ROUTES_TITLES.get(location.pathname as EAdminRoutes)}
                    </Typography.Title>
                </Flex>
            </Flex>
        </header>
    );
};
